import * as React from 'react';

/**
 * @description VK icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { VK } from '@sravni/design-system-icons'
 *
 * <VK />
 * ```
 */
const VK = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "VK", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M10.804 15.646c-6.15 0-9.658-4.216-9.804-11.232h3.08c.102 5.15 2.373 7.33 4.172 7.78v-7.78h2.9v4.441c1.777-.19 3.643-2.215 4.272-4.44h2.901c-.483 2.743-2.507 4.766-3.946 5.598 1.439.675 3.744 2.44 4.62 5.633h-3.192c-.686-2.136-2.395-3.789-4.655-4.014v4.014h-.348Z", fill: "currentColor" }))));

export { VK };
//# sourceMappingURL=VK.js.map
